import React, { useEffect } from "react";
import { styled } from '@mui/material/styles';
import { useHistory } from "react-router-dom";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { parseSearch } from "../../../actions/helpers";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  sortAnalysesByDate,
  sortAnalysesByAlpha,
  sortAnalysesByEconomicLosses,
} from "../../../actions/details";

const PREFIX = 'AnalysisSort';

const classes = {
  root: `${PREFIX}-root`,
  formControl: `${PREFIX}-formControl`,
  selectEmpty: `${PREFIX}-selectEmpty`
};

const Root = styled('div')((
  {
    theme
  }
) => ({
	[`& .${classes.formControl}`]: {
      margin: theme.spacing(1),
      minWidth: "12rem",
      marginTop: "11px",
  },

  [`& .${classes.selectEmpty}`]: {
    marginTop: theme.spacing(2),
    "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      background: "#fff",
      padding: "0 0.7em",
    },
  }
}));

const StyledFormControl = styled(FormControl)((
  {
    theme
  }
) => ({
  [`&.${classes.formControl}`]: {
    margin: theme.spacing(1),
    minWidth: "12rem",
    marginTop: "11px",
  },

  [`& .${classes.selectEmpty}`]: {
    marginTop: theme.spacing(2),
    "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      background: "#fff",
      padding: "0 0.7em",
    },
  }
}));

const AnalysisSort = ({
  analyses,
  sortAnalysesByDate,
  sortAnalysesByAlpha,
  sortAnalysesByEconomicLosses,
}) => {

  const history = useHistory();
  const [filter, setFilter] = React.useState("");

  const setHistory = (key, param) => {
    const searchParams = parseSearch();
    param.length === 0 ? delete searchParams[key] : (searchParams[key] = param);
    const params = new URLSearchParams(searchParams).toString();
    const search = params.includes("?") ? `${params}` : `?${params}`;
    history.push({
      pathname: "/details",
      search: search,
    });
  };

  const handleChange = (event) => {
    const value = event.target.value;
    switch (value) {
      case "new-old":
      case "old-new":
        sortAnalysesByDate(value);
        break;
      case "a-z":
      case "z-a":
        sortAnalysesByAlpha(value);
        break;
      case "losses-low-high":
      case "losses-high-low":
        sortAnalysesByEconomicLosses(value);
        break;
      default:
        sortAnalysesByAlpha("a-z");
    }
    setFilter(value);
    setHistory("sort", value);
  };

  useEffect(() => {
    const param = "sort";
    try {
      const searchParams = parseSearch();
      if (Object.keys(searchParams).includes(param)) {
        const value = decodeURIComponent(searchParams[param]);
        const event = { target: { value: value } };
        handleChange(event);
      } else {
        const event = { target: { value: "a-z" } };
        handleChange(event);
      }
    } catch (error) {
      console.error({
        msg: `error setting params for ${param}`,
        error: error.message,
      });
    }
  }, [analyses.length]);

  return (
	<Root className={classes.root}>
		<div>
		    <StyledFormControl size="small" className={classes.formControl}>
		      <InputLabel id="demo-simple-select-outlined-label">Sort by</InputLabel>
		      <Select
		        labelId="demo-simple-select-outlined-label"
		        id="demo-simple-select-outlined"
		        value={filter}
		        onChange={handleChange}
		        label="Date"
		      >
		        <MenuItem value="">
		          <em>None</em>
		        </MenuItem>
		        <MenuItem value={"a-z"}>Analysis Name: A to Z</MenuItem>
		        <MenuItem value={"z-a"}>Analysis Name: Z to A</MenuItem>
		        <MenuItem value={"new-old"}>Analysis Date: Newest to Oldest</MenuItem>
		        <MenuItem value={"old-new"}>Analysis Date: Oldest to Newest</MenuItem>
		        <MenuItem value={"losses-high-low"}>
		          Economic Loss: Low to High
		        </MenuItem>
		        <MenuItem value={"losses-low-high"}>
		          Economic Loss: High to Low
		        </MenuItem>
		      </Select>
		    </StyledFormControl>
		</div>
	</Root>
  );
};

AnalysisSort.propTypes = {
  sortAnalysesByDate: PropTypes.func.isRequired,
  sortAnalysesByAlpha: PropTypes.func.isRequired,
  sortAnalysesByEconomicLosses: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  analyses: state.details.analyses,
});

export default connect(mapStateToProps, {
  sortAnalysesByDate,
  sortAnalysesByAlpha,
  sortAnalysesByEconomicLosses,
})(AnalysisSort);
